import { memo } from "react";

import { FeatureIslandMainWithBackGround } from "@/components/features/_layouts";
import { QuestionForMain } from "@/components/features/_layouts/island/main/question";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";
import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

import type { MagazineAnalyticsSettingFormModel } from "../../model/type";
import type { MagazineAnalyticsSettingFormModelMethodsType } from "../../model/use-case/use-create-model/methods";

type Props = {
	viewModel: MagazineAnalyticsSettingFormModel["ViewModel"];

	onSetPixelAvailable: MagazineAnalyticsSettingFormModelMethodsType["magazineAnalyticsSettingFormModelMethods"]["onSetPixelAvailable"];
	onSetPixelID: MagazineAnalyticsSettingFormModelMethodsType["magazineAnalyticsSettingFormModelMethods"]["onSetPixelID"];
};

export const DesignMagazineAnalyticsSettingPixelIsland = memo(
	({ viewModel, onSetPixelAvailable, onSetPixelID }: Props) => {
		const { pixelAvailable, pixelID } = viewModel;

		return (
			<FeatureIslandMainWithBackGround islandTitle="Facebook Pixel設定">
				<QuestionForMain
					required={false}
					title={"Facebook Pixelの設定"}
					guide="CHILLNNではpixelを利用して、Facebook広告のトラッキングを行うことができます。"
					inputChildren={
						<>
							<CheckboxField
								value={pixelAvailable.value}
								errorMessage={pixelAvailable.error}
								label={"Facebook pixelを設定する"}
								handleChange={onSetPixelAvailable}
							/>
							{pixelAvailable.value && (
								<InputTextField
									className="w-full xl:w-1/2"
									value={pixelID?.value}
									label="pixel IDを入力してください。（ ex.「123456789012345」）"
									errorMessage={pixelID?.error}
									handleChange={onSetPixelID}
								/>
							)}
						</>
					}
				/>
			</FeatureIslandMainWithBackGround>
		);
	},
);

DesignMagazineAnalyticsSettingPixelIsland.displayName = "DesignMagazineAnalyticsSettingPixelIsland";
